export default [
  {
    path: '/envio-app',
    component: () => import('@/pages/EnvioApp/Template.vue'),
    children: [
      {
        path: '/envio-app',
        component: () => import('@/pages/EnvioApp/Index.vue'),
      },
    ],
  },
]
